export const stripRouteHyphens = (value) => String(value ?? '').replace(/-/g, '');
